import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { OidcSecurityService } from 'angular-auth-oidc-client'
import { switchMap } from 'rxjs/operators'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oidcSecurityService = inject(OidcSecurityService)

  // Only add the token for requests to the Albert-API
  if (!req.url.includes('/api/')) {
    return next(req)
  }

  return oidcSecurityService.getAccessToken().pipe(
    switchMap((token) => {
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      }
      return next(req)
    })
  )
}
